import SFS2X from "sfs2x-api";

export function attachSFSToLogger(sfs)
{
    sfs.logger.level = SFS2X.LogLevel.DEBUG;
    sfs.logger.enableConsoleOutput = true;
    sfs.logger.enableEventDispatching = false;

    sfs.logger.addEventListener(SFS2X.LoggerEvent.DEBUG, onDebug, this);
    sfs.logger.addEventListener(SFS2X.LoggerEvent.INFO, onInfo, this);
    sfs.logger.addEventListener(SFS2X.LoggerEvent.WARNING, onWarning, this);
    sfs.logger.addEventListener(SFS2X.LoggerEvent.ERROR, onError, this);
}

function onDebug(event)
{
    console.log("SFS-DEBUG: " + event.message);
}

function onInfo(event)
{
    console.log("SFS-INFO: " + event.message);
}

function onWarning(event)
{
    console.log("SFS-WARNING: " + event.message);
}

function onError(event)
{
    console.log("SFS-ERROR: " + event.message);
}